import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import StockService from 'Service/stock';
import Attractive from 'Container/stock/attractive';
import FearGreed from 'Container/stock/fear_greed';
import Consensus from 'Container/stock/consensus';
import TradeSignal from 'Container/stock/trade_signal';
import Howto from 'Container/stock/howto';
import { Helmet } from 'react-helmet-async';
import GuideStock from 'Component/guide/stock';
import ComplianceNote from 'Component/stock/compliance_note';
import EmptyStock from 'Component/empty_stock';

const AISignal = () => {
  const { tickerDetail, ticker, hasLoadedTicker } = useSelector((state) => state.stock);

  const [showEmpty, setShowEmpty] = useState(false);

  useEffect(() => {
    let t;
    if (ticker && hasLoadedTicker && tickerDetail === null) {
      t = setTimeout(() => setShowEmpty(true), 300);
    } else {
      setShowEmpty(false);
    }
    return () => clearTimeout(t);
  }, [tickerDetail, ticker, hasLoadedTicker]);

  return (
    <>
      <Helmet>
        <title>MTN AI Signal</title>
      </Helmet>
      <div id="stock">
        <div className="container">
          <StockService />
          { tickerDetail && Number(tickerDetail.STK_TYP) === 1 && (
            <>
              <Attractive />
              <FearGreed />
              <Consensus />
              <TradeSignal />
              <Howto />
              <ComplianceNote mode="signal" />
            </>
          )}
          { tickerDetail && Number(tickerDetail.STK_TYP) === 2 && (
            <>
              <Attractive />
              <FearGreed />
              <TradeSignal />
              <Howto />
              <ComplianceNote mode="signal" />
            </>
          )}
          { showEmpty && <EmptyStock /> }
          <GuideStock />
        </div>
      </div>
    </>
  )
}

export default AISignal;
